<template>
  <div class="quota">
    <mt-header fixed title="额度" class="title1">
      <mt-button slot="left" icon="back" @click="handleBackClickEvent">返回</mt-button>
    </mt-header>
    <div class="container">
      <div v-for="(item, index) in quotaMoneyList" :key="index">
        <div>
          <span>{{ item.money | formatMoney }}</span>
        </div>
        <div>
          <span>每日总额度(元)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_QUOTA_MONEY_LIST */

export default {
  name: 'Quota',
  data() {
    return {
      moneyList: PUBLIC_QUOTA_MONEY_LIST,
    };
  },
  computed: {
    quotaMoneyList() {
      return this.moneyList;
    },
  },
  methods: {
    handleBackClickEvent() {
      window.location.href = 'protocol://android';
    },
  },
  filters: {
    formatMoney(num) {
      let result = '';
      let str = (num || 0).toString();
      while (str.length > 3) {
        result = ',' + str.slice(-3) + result;
        str = str.slice(0, str.length - 3);
      }
      if (str) {
        result = str + result;
      }
      return result;
    },
  },
};
</script>
